import "./SeoOpenGraphStyleSheet.scss"
import RaikoGridOneColumn from "../../raikoComponents/raikoCustomGrids/RaikoGridOneColumn";
import RaikoSimpleInputOutlined from "../../raikoComponents/raikoCustomInput/RaikoSimpleInputOutlined";
import RaikoSimpleMultiLineInputOutlined
    from "../../raikoComponents/raikoCustomInput/RaikoSimpleMultiLineInputOutlined";
import {css} from "@emotion/css";
import {RaikoCustomTooltip} from "../../raikoComponents/raikoTooltip/RaikoCustomTooltip";

export default function (
    {
        schema,
        setSchema
    }
) {

    function handleAddNewItem() {
        setSchema(prev => [
            ...prev,
            {
                property: "",
                content: ""
            }
        ])
    }

    function handleDeleteItem(itemIndex) {
        const _schema = []

        schema.map((item, index) => {
            if (index !== itemIndex)
                _schema.push(item)
        })

        setSchema(_schema)
    }

    return (
        <div className={"schemaBaseContainer"}>
            <RaikoGridOneColumn>
                <span>Open Graph</span>
                <RaikoGridOneColumn className={"openGraphItemsContainer"}>
                    {schema && schema.length > 0 &&
                        schema.map((item, index) => {
                            return <div className={"openGraphItem"}>
                                <RaikoGridOneColumn className={css`flex-grow: 1`}>
                                    <RaikoSimpleInputOutlined
                                        labelText={"property"}
                                        setValue={e => {
                                            const _schema = []
                                            _schema.push(...schema)
                                            _schema[index].property = e
                                            setSchema(_schema)
                                        }}
                                        value={item.property}/>

                                    <RaikoSimpleMultiLineInputOutlined
                                        labelText={"content"}
                                        setValue={e => {
                                            const _schema = []
                                            _schema.push(...schema)
                                            _schema[index].content = e
                                            setSchema(_schema)
                                        }}
                                        value={item.content}
                                    />
                                </RaikoGridOneColumn>
                                <div className={"trashContainer"}>
                                    <RaikoCustomTooltip title="حذف">
                                        <div className={"icTrash"} onClick={_ => handleDeleteItem(index)}/>
                                    </RaikoCustomTooltip>
                                </div>
                            </div>
                        })
                    }
                    <section
                        onClick={handleAddNewItem}
                        className={"schemaAddNewItemContainer"}>
                        <span>+</span>
                    </section>
                </RaikoGridOneColumn>

            </RaikoGridOneColumn>
        </div>
    )
}